import { render, staticRenderFns } from "./SearchStudent.vue?vue&type=template&id=64733260&scoped=true&lang=pug"
import script from "./SearchStudent.vue?vue&type=script&lang=ts"
export * from "./SearchStudent.vue?vue&type=script&lang=ts"
import style0 from "./SearchStudent.vue?vue&type=style&index=0&id=64733260&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64733260",
  null
  
)

export default component.exports